import React from 'react';
import {
  SwapOutlined,
  BankOutlined,
  WalletOutlined,
  DollarCircleOutlined
} from '@ant-design/icons';
import { SectionHeader } from '../dashboard/shared/components/section-header';
import DashboardStatCard from '../../components/shared/DashboardStatCard';

const DashboardTab = ({ stats }) => {
  return (
    <div className="reg-dashboard-tab">
      <div className="reg-dashboard-section">
        <SectionHeader title="Key Business Metrics" />
        <div className="ds-stats-grid cols-4" style={{ marginBottom: '32px' }}>
          <DashboardStatCard
            icon={<SwapOutlined />}
            value={stats.totalTransactions || "₦0.00"}
            label="Total Transactions"
            iconBg="#fff3eb"
            iconColor="#ff6700"
          />
          <DashboardStatCard
            icon={<BankOutlined />}
            value={stats.accountBalances || "₦0.00"}
            label="Account Balances"
            iconBg="#f6ffed"
            iconColor="#52c41a"
          />
          <DashboardStatCard
            icon={<WalletOutlined />}
            value={stats.loanPortfolio || "₦0.00"}
            label="Loan Portfolio"
            iconBg="#e6f7ff"
            iconColor="#1890ff"
          />
          <DashboardStatCard
            icon={<DollarCircleOutlined />}
            value={stats.revenue || "₦0.00"}
            label="Total Revenue"
            iconBg="#fffbe6"
            iconColor="#faad14"
          />
        </div>

      </div>
    </div>
  );
};

export default DashboardTab;
